import { useLocation } from 'react-router-dom';
import { useMemo, useCallback, useRef } from 'react';
import { useNavigate } from './navigate';
export function useSearchParams(defaults) {
    const defaultsRef = useRef(defaults);
    const location = useLocation();
    const navigate = useNavigate();
    const params = useMemo(() => {
        const params = new URLSearchParams(location.search);
        const defaults = defaultsRef.current;
        if (defaults) {
            const defaultEntries = Object.entries(defaults).filter(([key]) => !params.has(key));
            for (const [key, value] of defaultEntries) {
                [].concat(value).forEach(v => params.append(key, v));
            }
        }
        return params;
    }, [location.search]);
    const update = useCallback((patch, navigateOptions) => {
        const params = new URLSearchParams(location.search);
        for (const [key, value] of Object.entries(patch)) {
            if (value == null) {
                params.delete(key);
            }
            else if (Array.isArray(value)) {
                params.delete(key);
                value.forEach((v) => params.append(key, String(v)));
            }
            else {
                params.set(key, String(value));
            }
        }
        const newLocation = Object.assign(Object.assign({}, location), { search: params.toString() });
        navigate(newLocation, navigateOptions);
    }, [location, navigate]);
    return [params, update];
}
export function useSearchParam(key) {
    const [params] = useSearchParams();
    return params.get(key);
}
export function useSearchParamAll(key) {
    const [params] = useSearchParams();
    return params.getAll(key);
}
export function useUpdateSearchParams() {
    const hook = useSearchParams();
    return hook[1];
}
export function useSearchParamState(key, options = {}) {
    const value = useSearchParam(key);
    const update = useUpdateSearchParams();
    const setValue = useCallback((value) => update({ [key]: value }, { replace: options.replace }), [key, options.replace, update]);
    return [value, setValue];
}
//# sourceMappingURL=search.js.map